import type { Reroute } from "@sveltejs/kit";

export const reroute: Reroute = ({ url }) => {
	if (url.pathname.startsWith("/u/")) {
		return url.pathname.replace("/u/", "/user/");
	}

	if (url.pathname.startsWith("/hive")) {
		return url.pathname.replace("/hive", "/templates");
	}
};
